// src/utils/logger.js

const isDevelopment = import.meta.env.MODE === 'development';

/**
 * A custom logger that only logs in development mode.
 * @param {string} message - The message to log.
 * @param  {...any} args - Additional arguments to log.
 */
export const logger = (message, ...args) => {
  if (isDevelopment) {
    console.log(message, ...args);
  }
};
